import styled from 'styled-components'

export const BillingNoticeWrapper = styled.div`
  width: 100%;
  background: rgba(217, 222, 225, 0.15);
  border-radius: 8px;
  padding: 24px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  h4 {
    margin: 0 0 4px;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
  }
`
